module.exports = __webpack_public_path__ + "static/img/4.6123618.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/line/4.jpg
// module id = 05Uf
// module chunks = 1